import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getFormattedDate } from "../../functions/time";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../button/ButtonPrimary";
import { toast } from "react-toastify";
import Draggable from "react-draggable";

const DateComponent = (props) => {
  const {
    reqDate,
    setCalendarPopup,
    setDate,
    requiredDates,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
  } = props;

  const [tempDate, setTempDate] = useState(reqDate);

  const currentYear = new Date().getFullYear();

  const dynamicYearOptions = () => {
    const years = [];
    for (let year = 1990; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };

  const [position, setPosition] = useState({
    marginTop: 0,
    marginLeft: 0,
  });

  const yearOptions = dynamicYearOptions();

  const CustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return (
      <div className="datepicker-header">
        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          {"<"}
        </button>
        <div>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {yearOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          {">"}
        </button>
      </div>
    );
  };

  const handleSubmit = () => {
    if (requiredDates !== 2) {
      if (!tempDate) {
        toast.error("Please select a date.");
        return;
      }
      setDate(tempDate);
      setCalendarPopup(false);
    } else {
      if (!fromDate && !toDate) {
        toast.error("Please select valid dates.");
        return;
      }
      if (fromDate >= toDate) {
        toast.error("Start date must be earlier than end date.");
        return;
      }
      setDate();
      setCalendarPopup(false);
    }
  };

  const DatePickerComponent = () => {
    if (!requiredDates)
      return (
        <div className="datepicker">
          <p className="title">
            Selected Date: {tempDate && getFormattedDate(tempDate)}
          </p>
          <DatePicker
            wrapperClassName="datepicker"
            selected={tempDate}
            renderCustomHeader={(props) => <CustomHeader {...props} />}
            onChange={(date) => {
              setTempDate(date);
            }}
            inline
            maxDate={new Date()}
          />
        </div>
      );
    return (
      <div className="datepicker-flex">
        <div>
          <p className="title">
            From Date: {fromDate && getFormattedDate(fromDate)}
          </p>
          <DatePicker
            wrapperClassName="datepicker"
            selected={fromDate}
            renderCustomHeader={(props) => <CustomHeader {...props} />}
            onChange={(date) => {
              setFromDate(date);
            }}
            inline
            maxDate={new Date()}
          />
        </div>
        <div>
          <p className="title">To Date: {toDate && getFormattedDate(toDate)}</p>
          <DatePicker
            wrapperClassName="datepicker"
            selected={toDate}
            renderCustomHeader={(props) => <CustomHeader {...props} />}
            onChange={(date) => {
              setToDate(date);
            }}
            inline
            maxDate={new Date()}
          />
        </div>
      </div>
    );
  };

  const handleDrag = (e, ui) => {
    const { x, y } = ui;
    setPosition((prevPosition) => ({
      ...prevPosition,
      marginTop: y,
      marginLeft: x,
    }));
  };

  return (
    // <Draggable
    //   position={{
    //     x: position.marginLeft,
    //     y: position.marginTop,
    //   }}
    //   onDrag={handleDrag}
    // >
    <div className="custom-datepicker">
      <div className="bg-dark-datepicker"></div>
      <div className="container-datepicker-custom">
        <div>
          <CloseIcon
            className="close-icon"
            onClick={() => {
              fromDate && setFromDate(null);
              toDate && setToDate(null);
              setCalendarPopup(false);
            }}
          />
        </div>
        <div className="custom-datepicker flex-gap">
          <div className="content-datepicker">
            <DatePickerComponent />
          </div>
        </div>
        <div className="search-container">
          <ButtonPrimary
            className="search-btn"
            onClick={handleSubmit}
            text="select"
          />
        </div>
      </div>
    </div>
    // </Draggable>
  );
};

export default DateComponent;
